import { useState } from 'react';
import { FillButton, Modal as BaseModal, ModalActions, ModalContent, ModalToolbar, OutlineButton } from '@recargas-dominicanas/core/components';
import type { IBusinessUser } from '@recargas-dominicanas/core/types';
import { style } from './business-user-confirm-modal.module.css';

interface Props {
  open: boolean;
  title: string;
  description: string;
  businessUser: IBusinessUser;
  onConfirm: () => void;
  onClose: () => void;
}

export function BusinessUserConfirmModal(props: Props) {

  const { open, title, description, businessUser, onConfirm, onClose } = props;

  const [check, setCheck] = useState(false);

  function handleClose() {
    setCheck(false);
    onClose();
  }

  function handleConfirm() {
    onConfirm();
    handleClose();
  }

  return (
    <BaseModal open={open} style={style.deleteModal} onClose={handleClose}>
      <ModalToolbar title={title} style={style.toolbar} onClose={handleClose}/>
      <ModalContent>
        <div className={style.item}>
          <span className={style.itemTitle}>{businessUser.name}</span>
          <span className={style.username}>{businessUser.userName}</span>
        </div>
        <label className={style.label}>
          <input
            type='checkbox'
            checked={check}
            className={style.checkbox}
            onChange={() => setCheck(value => !value)}/>
          {description}
        </label>
      </ModalContent>
      <ModalActions>
        <OutlineButton text='Cancelar' onClick={handleClose}/>
        <FillButton text='Aceptar' disabled={!check} onClick={handleConfirm}/>
      </ModalActions>
    </BaseModal>
  );
}
